<template>
    <Dialog class="p-dialog-maximized template-dialog" v-model:visible="isVisible" :draggable="false" :style="{width: '80vw'}" :closable="false" @show="setKeyPressDetection" @hide="removeKeyPressDetection">
        <template #header>
            <div class="row col-md-12">
                <div class="row col-md-12">
                    <div class="col-md-9">
                        <div v-if="contentIndex == 0">
                            <span class="p-dialog-title">{{ headerCode }} - {{ header }}</span>
                        </div>

                        <div v-else>
                            <span class="p-dialog-title">{{ navigateValue.code }} - {{ navigateValue.name }}</span>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="d-flex justify-content-end" style="align-items: center;">
                            <Menu ref="rowMenu" :model="rowMenuItems" :popup="true" />
                            <Menu ref="columnMenu" :model="columnMenuItems" :popup="true" />
                            <Menu ref="cellMenu" :model="cellMenuItems" :popup="true" />

                            <div class="col-md-12" v-if="contentIndex == 0">
                                <div class="col-md-12 d-flex justify-content-end" v-if="this.identifier == null">
                                    <TheLoading v-if="isLoading"></TheLoading>

                                    <Button class="p-button-sm" @click="save" label="Save" :disabled="isLoading || isPageLoading" />
                                    <span class="p-1"></span>
                                    <Button class="p-button-sm" @click="preview" label="Preview" :disabled="isLoading || isPageLoading" />
                                    <Button class="p-dialog-header-icons" icon="pi pi-times" severity="secondary" text rounded @click="cancel" aria-label="Cancel" :disabled="isPageLoading"/>
                                </div>

                                <div class="col-md-12 d-flex justify-content-end" v-else>
                                    <TheLoading v-if="isLoading"></TheLoading>
                                    <Button class="p-button-sm p-button-warning" :label="(this.publishedDate == null ? 'Draft' : 'Published') + ' Version ' + this.version" :disabled="true"/>
                                    <span class="p-1"></span>
                                    <Button class="p-button-sm" @click="update" label="Save" :disabled="isLoading || isPageLoading" v-if="this.publishedDate == null" />
                                    <!--<Button class="p-button-sm" @click="preview" label="Preview" :disabled="isLoading" />-->
                                    <Button class="p-dialog-header-icons" icon="pi pi-times" severity="secondary" text rounded @click="cancel" aria-label="Cancel" :disabled="isPageLoading"/>
                                </div>
                            </div>

                            <div class="col-md-12" v-else>
                                <div class="col-md-12 d-flex justify-content-end">
                                    <Button class="p-button-sm" @click="onNavigateBack" label="Back" :disabled="isPageLoading"/>
                                    <Button class="p-dialog-header-icons" icon="pi pi-times" severity="secondary" text rounded @click="cancel" aria-label="Cancel" :disabled="isPageLoading"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col-md-12">
                    <div class="col-md-12 pt-2 pb-0">
                        <div v-if="contentIndex == 0" :style="{'visibility': isShowFormulaHeader ? 'visible' : 'hidden'}">
                            <div>
                                <h6>{{ cellTitleHeader }}</h6>
                            </div>
                            <div>
                                <h6>{{ formulaHeader }}</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row col-md-12">
                    <div class="d-flex justify-content-center align-items-start" v-if="styleComponent.visible">
                        <TheStyle :reloadKey="(styleComponent.rowIndex + '' + styleComponent.columnIndex)" :cssStyle="styleComponent.style" @updateStyleEvent="updateStyle" @updateSettingsEvent="updateSettings"></TheStyle>
                        <TheCellSettings :styleComponent="styleComponent" @update-settings-event="updateSettings"/>
                    </div>                    
                </div>
            </div>
        </template>

        <div class="m-0">
            <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>

            <div :class="'zoom-template-' + parseInt(zoomLevel * 100)" v-if="!isPageLoading">
                <div>
                    <div class="p-template-stick-header" style="top: 0;">
                        <div class="m-auto d-flex align-items-center justify-content-center position-relative" :style="{'width': tableWidth + 'rem'}">
                            <DataTable class="p-datatable-template p-datatable-template-header-only" :value="[]" showGridlines tableClass="editable-cells-table" :style="{'width': tableWidth + 'rem'}">
                                <Column field="" header="" class="p-template-column-number">
                                    <template #body="slotProps">
                                        <div class="d-flex">
                                            <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                        </div>
                                    </template>
                                </Column>

                                <Column v-for="(column, columnIndex) of columnHeaders" :key="column.header" :field="column.header" :header="column.header" :style="{'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem'}">
                                    <template #header>
                                        <span class="p-column-title-text">{{ column.header }}</span>
                                        <div class="p-column-title-header" v-if="this.publishedDate == null">
                                            <Button icon="pi pi-chevron-down" class="p-button-secondary p-button-title-collapsible" @click="toggleColumnMenu($event, columnIndex)" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div :class="{'d-flex' : isHorizontalScrollbar}" :style="{'width': !isHorizontalScrollbar ? 'auto' : (tableWidth + (contents[contentIndex].template == null ? 0 : (contents[contentIndex].template[0].columns.length * (parseInt(zoomLevel * 10) - 10))) + 'rem')}">
                        <div style="width:max-content; position:sticky; left:0; z-index:99" v-if="isHorizontalScrollbar">
                            <DataTable class="p-datatable-template p-datatable-template-body-only" :value="contents[contentIndex].template" showGridlines tableClass="editable-cells-table">
                                <Column field="index" header="" class="p-template-column-number">
                                    <template #body="slotProps">
                                        <div class="d-flex" :class="getBorder(slotProps.index)" v-tooltip.right="contents[contentIndex].template[slotProps.index].columns[0].value">
                                            <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                            <div class="p-row-title-header" v-if="this.publishedDate == null">
                                                <Button icon="pi pi-chevron-down" class="p-button-secondary p-button-title-collapsible" @click="toggleRowMenu($event, slotProps.index)" />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>

                        <div class="m-auto d-flex align-items-center justify-content-center position-relative" :style="{'width': tableWidth + 'rem'}" v-for="(content, index) in contents" :key="index">
                            <div v-if="index == contentIndex">
                                <div class="d-flex">
                                    <div class="m-0" v-if="contentIndex == 0">
                                        <DataTable class="p-datatable-template p-datatable-template-body-only" :value="contents[contentIndex].template" showGridlines tableClass="editable-cells-table" :style="{'width': tableWidth - (isHorizontalScrollbar ? 4 : 0) + (content.template[0].columns.length * (parseInt(zoomLevel * 10) - 10)) + 'rem'}">
                                            <Column field="" header="" class="p-template-column-number" v-if="!isHorizontalScrollbar">
                                                <template #body="slotProps">
                                                    <div class="d-flex">
                                                        <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                                        <div class="p-row-title-header" v-if="this.publishedDate == null">
                                                            <Button icon="pi pi-chevron-down" class="p-button-secondary p-button-title-collapsible" @click="toggleRowMenu($event, slotProps.index)" />
                                                        </div>
                                                    </div>
                                                </template>
                                            </Column>

                                            <Column v-for="(column, columnIndex) of columnHeaders" :key="column.header" :field="column.header" :header="column.header" class="p-template-column-cell" :style="[{'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem', 'padding': '0px'}]"
                                                    :pt="{
													bodycell: ({ parent, props }) => ({
														colspan: getCellColspan(parent.props.rowIndex, columnIndex),
														style: getCellDisplay(parent.props.rowIndex, columnIndex),
													})
												}"
                                            >
                                                <template #header>
                                                    <span class="p-column-title-text">{{ column.header }}</span>
                                                    <div class="p-column-title-header" v-if="this.publishedDate == null">
                                                        <Button icon="pi pi-chevron-down" class="p-button-secondary p-button-title-collapsible" @click="toggleColumnMenu($event, columnIndex)" />
                                                    </div>
                                                </template>

                                                <template #body="slotProps">
                                                    <div :style="(slotProps.data.columns[columnIndex] == null ? null : slotProps.data.columns[columnIndex].style)" class="row col-md-12 p-cell-body" :class="column.header + (slotProps.index + 1)">
                                                        <div class="p-cell-body-component" style="width: calc(100% - 1.7rem);">
                                                            <div v-if="slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null" v-tooltip.top="{value: slotProps.data.columns[columnIndex].component, disabled: slotProps.data.columns[columnIndex].component == null}">
                                                                <div v-if="slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'VALUE' || slotProps.data.columns[columnIndex].component == 'NAVIGATE'">
                                                                    <div class="p-inputgroup" @focusin="inputFocus(slotProps.index, columnIndex)">
                                                                        <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                        <Button icon="pi pi-align-justify" severity="warning" :disabled="this.publishedDate != null" @click="slotProps.data.columns[columnIndex].component == 'FORMULA' ? openFormulaDialog(slotProps.index, columnIndex, false) : openValueDialog(slotProps.index, columnIndex)"/>
                                                                    </div>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LABEL'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'HEADER'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" @update:modelValue="updateHeader(columnIndex, true)" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGLABEL'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'DATETIME'">
                                                                    <TheDateTimeDropdown
                                                                        :modelValue="slotProps.data.columns[columnIndex].value"
                                                                        @update:modelValue="value => slotProps.data.columns[columnIndex].value = value"
                                                                        :disabled="publishedDate != null"
                                                                        @focusin="inputFocus(slotProps.index, columnIndex)"
                                                                        @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" 
                                                                    />
                                                                </div>

                                                                <!-- <div v-else-if="slotProps.data.columns[columnIndex].component == 'NAVIGATE'">
                                                                    <Dropdown class="p-cell-body-component-navigate" v-model="navigateValue" filter :options="sheets" optionLabel="code" placeholder="Select a Sheet" :disabled="this.publishedDate != null" @change="onNavigateChange(slotProps.index, columnIndex)" :inputStyle="{'color':'inherit'}" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])">
                                                                        <template #value="dropdownProps">
                                                                            <div v-if="slotProps.data.columns[columnIndex].value" class="flex align-items-center">
                                                                                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 4.0rem;">{{ slotProps.data.columns[columnIndex].value }}</div>
                                                                            </div>

                                                                            <span v-else>
																				{{ dropdownProps.placeholder }}
																			</span>
                                                                        </template>

                                                                        <template #option="dropdownProps">
                                                                            <div class="flex align-items-center p-dropdown-item-navigate">
                                                                                <i class="pi pi-spin pi-spinner text-danger" v-if="dropdownProps.option.isLoading" />
                                                                                <i class="pi pi-times text-danger" v-if="!dropdownProps.option.isLoading && dropdownProps.option.isError" />
                                                                                <i class="pi pi-check text-success" v-if="!dropdownProps.option.isLoading && !dropdownProps.option.isError" />
                                                                                <span class="p-1"></span>
                                                                                <div>{{ dropdownProps.option.code }}</div>
                                                                            </div>
                                                                        </template>
                                                                    </Dropdown>
                                                                </div> -->

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'NUMBER'">
                                                                    <TheNumberDropdown
                                                                        :modelValue="slotProps.data.columns[columnIndex].value"
                                                                        @update:modelValue="value => slotProps.data.columns[columnIndex].value = value"
                                                                        :disabled="publishedDate != null"
                                                                        @focusin="inputFocus(slotProps.index, columnIndex)"
                                                                        @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])"
                                                                    />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'HEADERTEXT'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGTEXT'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" placeholder="Company" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" readonly @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" placeholder="Company Dropdown" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" readonly @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COUNTRY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" placeholder="Country" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" readonly @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'CURRENCY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" placeholder="Currency" :disabled="this.publishedDate != null" @focusin="inputFocus(slotProps.index, columnIndex)" readonly @focus="onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex])" />
                                                                </div>
                                                            </div>

                                                            <div v-else-if="slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null">
                                                                <InputText v-model="slotProps.data.columns[columnIndex].value" style="visibility: hidden;" />
                                                            </div>
                                                        </div>

                                                        <div v-if="publishedDate == null" class="p-cell-body-menu" style="width: 1.5rem;">
                                                            <div>
                                                                <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component == null && this.publishedDate == null" class="p-cell-body-menu-item-top">
                                                                    <Button icon="pi pi-chevron-down" class="p-button-primary p-button-cell-collapsible" @click="toggleCellMenu($event, slotProps.field + (slotProps.index + 1))" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex] != null && this.publishedDate == null" class="p-cell-body-menu-item-top">
                                                                    <Button icon="pi pi-times" class="p-button-danger p-button-cell-collapsible" @click="removeCellComponent(slotProps.field + (slotProps.index + 1), slotProps.data.columns[columnIndex].component)" />
                                                                </div>

                                                                <div class="p-cell-body-menu-item-bottom">
                                                                    <Button icon="pi pi-palette" class="p-button-primary p-button-cell-collapsible" @click="showStyle(slotProps.index, columnIndex, false)" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </Column>
                                        </DataTable>
                                    </div>

                                    <div class="m-0" v-else>
                                        <DataTable class="p-datatable-template p-datatable-template-body-only" :value="contents[contentIndex].template" showGridlines tableClass="editable-cells-table" :style="{'width': tableWidth - (isHorizontalScrollbar ? 4 : 0) + (content.template[0].columns.length * (parseInt(zoomLevel * 10) - 10)) + 'rem'}">
                                            <Column field="" header="" class="p-template-column-number" v-if="!isHorizontalScrollbar">
                                                <template #body="slotProps">
                                                    <div class="d-flex">
                                                        <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                                    </div>
                                                </template>
                                            </Column>

                                            <Column v-for="(column, columnIndex) of columnHeaders" :key="column.header" :field="column.header" :header="column.header" class="p-template-column-cell" :style="[{'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem', 'padding': '0px'}]"
                                                    :pt="{
													bodycell: ({ parent, props }) => ({
														colspan: getCellColspan(parent.props.rowIndex, columnIndex),
														style: getCellDisplay(parent.props.rowIndex, columnIndex),
													})
												}"
                                            >
                                                <template #header>
                                                    <span class="p-column-title-text">{{ column.header }}</span>
                                                </template>

                                                <template #body="slotProps">
                                                    <div :style="(slotProps.data.columns[columnIndex] == null ? null : slotProps.data.columns[columnIndex].style)" class="row col-md-12 p-cell-body" :class="column.header + (slotProps.index + 1)">
                                                        <div class="p-cell-body-component" style="width: calc(100% - 1.7rem);">
                                                            <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null">
                                                                <div v-if="slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'VALUE' || slotProps.data.columns[columnIndex].component == 'NAVIGATE'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LABEL'">
                                                                    <label>{{ slotProps.data.columns[columnIndex].value }}</label>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGLABEL'">
                                                                    <label>{{ slotProps.data.columns[columnIndex].value }}</label>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'DATETIME'">
                                                                    <TheDateTimeDropdown
                                                                        :modelValue="slotProps.data.columns[columnIndex].value"
                                                                        :disabled="true"
                                                                    />
                                                                </div>

                                                                <!-- <div v-else-if="slotProps.data.columns[columnIndex].component == 'NAVIGATE'">
                                                                    <Dropdown class="p-cell-body-component-navigate" v-model="slotProps.data.columns[columnIndex].value" editable filter showClear :options="sheets" optionLabel="code" placeholder="Select a Sheet" @change="onNavigateChange(slotProps.index, columnIndex)" :inputStyle="{'color': 'inherit'}" />
                                                                </div> -->

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'NUMBER'">
                                                                    <TheNumberDropdown
                                                                        :modelValue="slotProps.data.columns[columnIndex].value"
                                                                        :disabled="true"
                                                                    />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'TEXT'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGTEXT'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COUNTRY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'CURRENCY'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].value" />
                                                                </div>
                                                            </div>

                                                            <div v-else-if="slotProps.data.columns[columnIndex] != null">
                                                                <InputText v-model="slotProps.data.columns[columnIndex].value" style="visibility: hidden;" />
                                                            </div>
                                                        </div>

                                                        <div v-if="publishedDate == null" class="p-cell-body-menu" style="width: 1.5rem;">
                                                            <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'NUMBER' || slotProps.data.columns[columnIndex].component == 'NAVIGATE') && !navigateCell">
                                                                <Button icon="pi pi-check" class="p-button-success p-button-cell-collapsible" @click="navigateCellComponent(slotProps.field + (slotProps.index + 1))" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Dialog>

    <Dialog header="Formula" v-model:visible="formulaDialog.visible" :draggable="false" :style="{ width: '50vw' }" @hide="closeFormula()" @mousemove="onFormulaMouseMove()">
        <div class="row">
            <div class="col-md-12 p-4">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="col-form-label-title">Header:</label>
                    </div>

                    <div class="col-md-8">
                        <label class="col-form-label">{{ formulaDialog.header }}</label>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="col-form-label-title">Formula:</label>
                    </div>

                    <div class="col-md-7">
                        <InputText id="formula-input-text" class="p-inputtext" type="text" v-model="formulaDialog.formula" />
                    </div>

                    <div class="col-md-1" style="width: 1.5rem;">
                        <Button icon="pi pi-chevron-right" class="p-button-success p-button-cell-collapsible" :disabled="formulaDialog.formula == null || formulaDialog.formula == ''" @click="navigateCellComponent(null)" />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="col-form-label-title">Available Function:</label>
                    </div>

                    <div class="col-md-7">
                        <Dropdown v-model="formulaDialog.selectedFormula" :options="formulas" optionLabel="name" optionValue="value" placeholder="-- Please Select --" @change="appendFormula(null)" />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="col-form-label-title">From Sheet:</label>
                    </div>

                    <div class="col-md-7">
                        <Dropdown v-model="formulaDialog.selectedNavigate" filter :options="sheets" optionLabel="code" placeholder="Select a Sheet" @change="onNavigateChange(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex)" :autoOptionFocus="true" :filterFields="['code','name']">
                            <template #value="dropdownProps">
                                <div v-if="dropdownProps.value" class="row flex align-items-center">
                                    <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                    <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                </div>

                                <span v-else>
                                    {{ dropdownProps.placeholder }}
                                </span>
                            </template>

                            <template #option="dropdownProps">
                                <div class="row">
                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="row mb-3" v-if="noNavigateSheet">
                    <div class="col-md-12 text-center pe-5">
                        <span style="color:red">No available sheet to navigate</span>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="col-md-12 mt-2 d-flex">
                <div class="col-md-6 d-flex justify-content-start">
                </div>

                <div class="col-md-6 d-flex justify-content-end">
                    <Button class="p-button-text p-button-sm" label="Cancel" @click="closeFormula()" />
                    <span class="p-1"></span>
                    <Button class="p-button-sm" label="Save" @click="saveFormula" />
                </div>
            </div>
        </template>
    </Dialog>

    <Dialog header="RPK Value" v-model:visible="valueDialog.visible" :draggable="false" :style="{ width: '50vw' }" @hide="closeValue()">
        <div class="row">
            <div class="col-md-12 p-4">
                <div class="row mb-3">
                    <div class="col-md-4 required">
                        <label class="col-form-label-title">Value:</label>
                    </div>

                    <div class="col-md-7">
                        <InputText class="p-inputtext" type="text" v-model="valueDialog.value" />
                    </div>

                    <div class="col-md-1" style="width: 1.5rem;">
                        <Button icon="pi pi-chevron-right" class="p-button-success p-button-cell-collapsible" :disabled="valueDialog.value == null || valueDialog.value == ''" @click="navigateCellComponent(null)" />
                    </div>
                </div>
                    
                <div class="row mb-3">
                    <div class="col-md-4 required">
                        <label class="col-form-label-title">From RPK Sheet:</label>
                    </div>
                    
                    <div class="col-md-7">
                        <Dropdown v-model="valueDialog.selectedNavigate" filter :options="rpkSheets" optionLabel="code" placeholder="Select a Sheet" @change="onNavigateChange(this.valueDialog.rowIndex, this.valueDialog.columnIndex)" :autoOptionFocus="true" :filterFields="['code','name']">
                            <template #value="dropdownProps">
                                <div v-if="dropdownProps.value" class="row flex align-items-center">
                                    <span class="col-md-3">{{ dropdownProps.value.code }}</span>
                                    <span class="col-md-9">{{ dropdownProps.value.name }}</span>
                                </div>

                                <span v-else>
                                    {{ dropdownProps.placeholder }}
                                </span>
                            </template>

                            <template #option="dropdownProps">
                                <div class="row">
                                    <span class="col-md-3">{{ dropdownProps.option.code }}</span>
                                    <span class="col-md-9">{{ dropdownProps.option.name }}</span>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="row mb-3" v-if="noNavigateSheet">
                    <div class="col-md-12 text-center pe-5">
                        <span style="color:red">No available sheet to navigate</span>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="col-md-12 mt-2 d-flex">
                <div class="col-md-6 d-flex justify-content-start">
                    <Button class="p-button-sm p-button-warning" label="Clear Value" @click="clearValue" />
                </div>

                <div class="col-md-6 d-flex justify-content-end">
                    <Button class="p-button-text p-button-sm" label="Cancel" @click="closeValue()" />
                    <span class="p-1"></span>
                    <Button class="p-button-sm" label="Save" @click="saveValue" :disabled="v$.valueDialog.$invalid" />
                </div>
            </div>
        </template>
    </Dialog>
</template>

<script lang="ts">
    import { defineComponent, ref } from "vue";
    import sheetApi from "@/api/sheet-api";
    import templateApi from "@/api/template-api";
    import numberMixin from "@/mixin/number";
    import formulaMixin from "@/mixin/formula";
	import sheetTypeMixin from "@/mixin/sheet-type";

    import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
    import TheLoading from "@/components/TheLoading.vue";
    import TheStyle from "@/components/styles/TheStyle.vue";
    import TheCellSettings from "./styles/TheCellSettings.vue";
    import TheDateTimeDropdown from '@/components/TheDateTimeDropdown.vue';
    import TheNumberDropdown from '@/components/TheNumberDropdown.vue';

    import useVuelidate from "@vuelidate/core";
    import { required, requiredIf, minLength, helpers } from "@vuelidate/validators";

    const contains = (param: any) => (value: any) => !helpers.req(value) || value.includes(param);

    export default defineComponent({
        mixins: [numberMixin, formulaMixin, sheetTypeMixin],
        emits: ['publish', 'clone', 'save', 'update', 'cancel'],
        components: {
            TheTabViewLoading,
            TheLoading,
            TheStyle,
            TheCellSettings,
            TheDateTimeDropdown,
            TheNumberDropdown
        },
        data() {
            return {
                isVisible: false,
                isLoading: false,
                isPageLoading: false,
                sheetsTimeout: 0,
                contentIndex: 0,
                contents: [] as any[],
                template: {identifier: '', sheet: {identifier: ''}, version: '', publishedDate: ''},
                sheets: [] as any[],
                isRpkSheet: false,
                rpkSheets: [] as any[],
                navigateRowIndex: 0,
                navigateColumnIndex: 0,
                navigateValue: null as any,
                tableWidth: 0,
                columnHeaders: [] as any[],
                isHorizontalScrollbar: false,
                tempFormula: null,
                tempValue: null,
                isNavigate: false,
                navigateCell: false,
                noNavigateSheet: false,
                // The cell the grid last focused, so F9 knows which formula to follow.
                focusCell: {rowIndex: null as any, columnIndex: null as any},
                // A jump made with F9 starts from the grid, not from the formula/value dialog,
                // so going back has to land on the grid rather than reopen a dialog.
                shortcutNavigate: false,
                shortcutOrigin: {rowIndex: null as any, columnIndex: null as any},
                formulaDialog: {rowIndex: 0, columnIndex: 0, header: null as any, formulaInput: {startIndex: null as any, endIndex: null as any}, formula: null as any, selectedFormula: null as any, selectedNavigate: null as any, visible: false, loading: false},
                valueDialog: {rowIndex: 0, columnIndex: 0, value: null as any, selectedNavigate: null as any, visible: false, loading: false},
                styleComponent: {rowIndex: -1, columnIndex: -1, component: null as any, visible: false, style: null as any, settings: null as any, sheetInfo: null as any},
                zoomLevel: 1.0,
                zoomFactor: 0.1,
                navigateIds: [] as any[],
                formulaHeader: "-",
                cellTitleHeader: "-",
                isShowFormulaHeader: false,
                valueTimeout: 0,
                affectedSheetContents: [] as any[],
                rowMenuItems: [
                    {
                        label: 'Insert Above',
                        icon: 'pi pi-angle-double-up',
                        command: () => {
                            this.insertIntoAbove();
                        }
                    },
                    {
                        label: 'Insert Below',
                        icon: 'pi pi-angle-double-down',
                        command: () => {
                            this.insertIntoBelow();
                        }
                    },
                    {
                        label: 'Remove Row',
                        icon: 'pi pi-times',
                        command: () => {
                            this.removeRow();
                        }
                    },
                ],
                columnMenuItems: [
                    {
                        label: 'Insert Left',
                        icon: 'pi pi-angle-double-left',
                        command: () => {
                            this.insertIntoLeft();
                        }
                    },
                    {
                        label: 'Insert Right',
                        icon: 'pi pi-angle-double-right',
                        command: () => {
                            this.insertIntoRight();
                        }
                    },
                    {
                        label: 'Remove Column',
                        icon: 'pi pi-times',
                        command: () => {
                            this.removeColumn();
                        }
                    },
                ],
                cellMenuItems: [
                    {
                        label: 'Components',
                        items: [
                            {
                                label: 'Header',
                                command: () => {
                                    this.insertComponent('HEADER');
                                }
                            },
                            {
                                label: 'Header Text',
                                command: () => {
                                    this.insertComponent('HEADERTEXT');
                                }
                            },
                            {
                                label: 'Formula',
                                command: () => {
                                    this.insertComponent('FORMULA');
                                }
                            },
                            {
                                label: 'Label',
                                command: () => {
                                    this.insertComponent('LABEL');
                                }
                            },
                            {
                                label: 'Long Label',
                                command: () => {
                                    this.insertComponent('LONGLABEL');
                                }
                            },
                            {
                                label: 'Date Time',
                                command: () => {
                                    this.insertComponent('DATETIME');
                                }
                            },
                            // {
                            //     label: 'Navigate',
                            //     command: () => {
                            //         this.insertComponent('NAVIGATE');
                            //     }
                            // },
                            {
                                label: 'Number',
                                command: () => {
                                    this.insertComponent('NUMBER');
                                }
                            },
                            {
                                label: 'Text',
                                command: () => {
                                    this.insertComponent('TEXT');
                                }
                            },
                            {
                                label: 'Long Text',
                                command: () => {
                                    this.insertComponent('LONGTEXT');
                                }
                            },
                            {
                                separator: true
                            },
                            {
                                label: 'Company',
                                command: () => {
                                    this.insertComponent('COMPANY');
                                }
                            },
                            {
                                label: 'Company Dropdown',
                                command: () => {
                                    this.insertComponent('COMPANYDROPDOWN');
                                }
                            },
                            {
                                label: 'Country',
                                command: () => {
                                    this.insertComponent('COUNTRY');
                                }
                            },
                            {
                                label: 'Currency',
                                command: () => {
                                    this.insertComponent('CURRENCY');
                                }
                            },
                            {
                                label: 'RPK Value',
                                command: () => {
                                    this.insertComponent('VALUE');
                                }
                            },
                        ]
                    }
                ],
            };
        },
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            loading: {
                type: Boolean,
                required: true,
            },
            identifier: {
                type: Number,
                required: false
            },
            publishedDate: {
                type: String,
                required: false
            },
            status: {
                type: String,
                required: false
            },
            version: {
                type: Number,
                required: false
            },
            header: {
                type: String,
                required: false
            },
            headerCode: {
                type: String,
                required: false
            },
            sheetType: {
                type: String,
                required: false
            }
        },
        watch: {
            visible(newValue: any) {
                this.isVisible = newValue;
                this.styleComponent = {rowIndex: -1, columnIndex: -1, component: null, visible: false, style: null as any, settings: null as any, sheetInfo: null as any};

                this.contentIndex = 0;
                this.contents = [];
                this.sheets = [];
                this.navigateRowIndex = 0;
                this.navigateColumnIndex = 0;
                this.navigateValue = null;

                if (this.isVisible) {
                    this.isPageLoading = true;

                    var r1 = null as any;
                    var r2 = null as any;
                    var r3 = null as any;

                    if (this.identifier != null) {
                        r1 = templateApi.templateView(this.identifier);
                    }

                    r2 = sheetApi.sheetList({'code': this.headerCode}, this.sheetType);

                    if (this.sheetType == 'CWK') {
                        r3 = sheetApi.sheetList({'code': null}, 'RPK');
                    }

                    var content = null as any;
                    var template = null as any;

                    Promise.all([r1, r2, r3])
                        .then(async (values: any) => {
                            if (values != null) {
                                for (var i = 0; i < values.length; i++) {
                                    if (values[i] != null) {
                                        if (values[i].success) {
                                            if (values[i].data != null) {
                                                if (i == 0) {
                                                    this.template = values[i].data.template;
                                                    this.contents.push(values[i].data.template.content);
                                                }

                                                else if (i == 1) {
                                                    this.sheets = values[i].data.listSet;
                                                        if (this.sheets != null && this.sheets.length > 0) {
                                                            let request = null;
                                                            if (this.template.publishedDate == null){
                                                                request = {templateId: this.template.identifier, sheetId: this.template.sheet.identifier, version: this.template.version}
                                                            }
                                                            else{
                                                                request = {templateId: this.template.identifier, sheetId: this.template.sheet.identifier}
                                                            }
                                                            for (let x = 0; x < this.sheets.length; x++) {
                                                                await templateApi.templateViewBySheet(
                                                                    this.sheets[x].identifier,
                                                                    request
                                                                )
                                                                    .then(response => {
                                                                        this.sheets[x]['template'] = {};
                                                                        this.sheets[x]['template']['identifier'] = response.data.template.identifier;
                                                                        this.sheets[x]['template']['content'] = response.data.template.content;

                                                                        if (x == this.contentIndex) {
                                                                            this.setLongComponent();
                                                                        }
                                                                    })
                                                                    .catch(error => {
                                                                        this.sheets[x].isError = true;
                                                                    });
                                                            }
                                                            
                                                            this.sheets = this.sheets.filter(sheet => 'template' in sheet);
                                                        }
                                                }
                                                
                                                else if (i == 2) {
                                                    this.rpkSheets = values[i].data.listSet;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            if (this.identifier == null) {
                                content = {actions: [] as any[], template: [] as any[]};

                                for (var row = 1; row <= 20; row++) {
                                    template = [];
                                    for (var column = 1; column <= 2; column++) {
                                        template.push({'component': null, 'value': null});
                                    }
                                    content.template.push({'columns': template});
                                }
                                this.contents.push(content);
                            }

                            this.calculateTableWidthHeight();

                            this.isPageLoading = false;
                        })
                        .catch(error => {
                            this.isPageLoading = false;
                            this.$toast.add({severity: "error", summary: "Error", detail: error, life: 3000});
                        })
                        .finally(() => {
                            template = null;
                            content = null;
                            r2 = null;
                            r1 = null;
                        });
                }

                else {
                    this.navigateIds = [];
                    this.columnHeaders = [];
                    this.sheets = [];
                    this.contents = [];
                }
            },
            loading(newValue: any) {
                this.isLoading = newValue;
            },
            contentIndex(newValue: any) {
                this.setLongComponent();
            },
        },
        methods: {
            /**
             * Get the cell colspan if component is LONGLABEL or LONGTEXT.
             */
            getCellColspan(rowIndex: any, columnIndex: any){
                const cell = this.contents[this.contentIndex].template[rowIndex].columns[columnIndex];
                const isLongComponent = cell.component == 'LONGLABEL' || cell.component == 'LONGTEXT';
                if (!isLongComponent) return undefined;

                return 'settings' in cell && 'colspan' in cell.settings ? cell.settings.colspan : this.columnHeaders.length - columnIndex;
            },
            /**
             * Get the display value of the cell. Set to none if cell in merged cell range, else display as normal.
             */
            getCellDisplay(rowIndex: any, columnIndex: any) {
                const row = this.contents[this.contentIndex].template[rowIndex].columns;
                for (let i = columnIndex - 1; i >= 0; i--) {
                    const prev = row[i];
                    if (prev?.component == 'LONGLABEL' || prev?.component == 'LONGTEXT') {
                        const span = 'settings' in prev && 'colspan' in prev.settings ? prev.settings.colspan : this.columnHeaders.length - i;
                        if (i + span > columnIndex) {
                            return 'display: none';
                        }
                    }
                }
                return '';
            },            
            getBorder(rowIndex: any) {
                if (this.contents[this.contentIndex].template[rowIndex].columns != null) {
                    for (var i = 0; i < this.contents[this.contentIndex].template[rowIndex].columns.length; i++) {
                        if (this.contents[this.contentIndex].template[rowIndex].columns[i].style != null) {
                            if ("border-top-width" in this.contents[this.contentIndex].template[rowIndex].columns[i].style && "border-bottom-width" in this.contents[this.contentIndex].template[rowIndex].columns[i].style) {
                                if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-top-width"] == "1.5px") {
                                    return 'single-2-lines';
                                }

                                else if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-top-width"] == "4px") {
                                    return 'double-2-lines';
                                }
                            }

                            else if ("border-top-width" in this.contents[this.contentIndex].template[rowIndex].columns[i].style) {
                                if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-top-width"] == "1.5px") {
                                    return 'single-line';
                                }

                                else if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-top-width"] == "4px") {
                                    return 'double-line';
                                }
                            }

                            else if ("border-bottom-width" in this.contents[this.contentIndex].template[rowIndex].columns[i].style) {
                                if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-bottom-width"] == "1.5px") {
                                    return 'single-line';
                                }

                                else if (this.contents[this.contentIndex].template[rowIndex].columns[i].style["border-bottom-width"] == "4px") {
                                    return 'double-line';
                                }
                            }
                        }
                    }
                }
            },
            setLongComponent() {
                this.setHorizontalScrollbar();
            },
            setHorizontalScrollbar() {
                this.isHorizontalScrollbar = false;
                var dialogs = document.getElementsByClassName('p-dialog-content');
                if (dialogs != null && dialogs.length > 0) {
                    this.isHorizontalScrollbar = ((this.tableWidth + (this.columnHeaders.length * ((this.zoomLevel * 10) - 10))) * 16) > dialogs[0].clientWidth;
                }
            },
            calculateTableWidthHeight() {
                this.setColumnHeaders(this.contents[this.contentIndex].template);

                this.setHorizontalScrollbar();
            },
            setColumnHeaders(template: any) {
                this.columnHeaders = [];
                if (template != null && template.length > 0) {
                    for (var i = 0; i < template[0].columns.length; i++) {
                        this.columnHeaders.push({'header': this.getHeaderLetter(i), labelCount: 0});
                    }

                    this.tableWidth = 4 + (this.columnHeaders.length * 9) + 18;
                }

                else {
                    this.tableWidth = 20;
                }
            },
            insertIntoAbove() {
                if (this.cell.key != null) {
                    var columns = [];
                    for (var i = 1; i <= this.contents[this.contentIndex].template[0].columns.length; i++) {
                        columns.push({'component': null, 'value': null});
                    }

                    this.contents[this.contentIndex].template.splice(this.cell.key, 0, {'columns': columns});
                    this.contents[this.contentIndex].actions.push('+' + (this.cell.key + 1));

                    this.newRowFormula(this.cell.key, false);
                    columns = null as any;
                }
            },
            insertIntoBelow() {
                if (this.cell.key != null) {
                    var columns = [];
                    for (var i = 1; i <= this.contents[this.contentIndex].template[0].columns.length; i++) {
                        columns.push({'component': null, 'value': null});
                    }

                    this.contents[this.contentIndex].template.splice(this.cell.key + 1, 0, {'columns': columns});
                    this.contents[this.contentIndex].actions.push((this.cell.key + 1) + '+');

                    this.newRowFormula(this.cell.key, true);
                    columns = null as any;
                }
            },
            removeRow() {
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;

                try {
                    if (this.cell.key != null && this.contents[this.contentIndex].template.length > 1) {
                        this.contents[this.contentIndex].template.splice(this.cell.key, 1);
                        this.contents[this.contentIndex].actions.push((this.cell.key + 1) + '-');

                        for (var j = 0; j < this.contents[this.contentIndex].template.length; j++) {
                            for (var k = 0; k < this.contents[this.contentIndex].template[j].columns.length; k++) {
                                if (this.contents[this.contentIndex].template[j].columns[k].component == 'FORMULA' && this.contents[this.contentIndex].template[j].columns[k].value != null) {
                                    formulas = this.parseToken(this.contents[this.contentIndex].template[j].columns[k].value.substring(1), j, k);
                                    if (formulas != null && formulas.length > 0) {
                                        formulas.slice().reverse().forEach((formula: any) => {
                                            if (formula.type == 'operand' && formula.subtype != 'text' && formula.subtype != 'number') {
                                                if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                                    keys = formula.value.split(':');

                                                    letterStart = this.getLetter(keys[0]);
                                                    letterEnd = this.getLetter(keys[1]);
                                                    startNumber = this.getNumber(keys[0]);
                                                    endNumber = this.getNumber(keys[1]);

                                                    if (startNumber == (this.cell.key + 1) && endNumber == (this.cell.key + 1)) {
                                                        this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber) + ':' + (letterEnd + endNumber), '#REF!');
                                                    }

                                                    if (endNumber >= (this.cell.key + 1)) {
                                                        this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterEnd + endNumber), letterEnd + (endNumber - 1));
                                                    }

                                                    if (startNumber > (this.cell.key + 1)) {
                                                        this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber - 1));
                                                    }
                                                }

                                                else {
                                                    letterStart = this.getLetter(formula.value);
                                                    startNumber = this.getNumber(formula.value);

                                                    if (startNumber == (this.cell.key + 1)) {
                                                        this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), '#REF!');
                                                    }

                                                    else if (startNumber > (this.cell.key + 1)) {
                                                        this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber - 1));
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }

                        this.updateOtherTemplate(this.headerCode, this.cell.key, false, null, "row");
                    }
                }

                finally {
                    endNumber = null;
                    startNumber = null;
                    letterEnd = null;
                    letterStart = null;
                    keys = null;
                    formulas = null;
                }
            },
            insertIntoLeft() {
                if (this.cell.key != null) {
                    for (var i = 0; i < this.contents[this.contentIndex].template.length; i++) {
                        this.contents[this.contentIndex].template[i].columns.splice(this.cell.key, 0, {'component': null, 'value': null});
                    }
                    this.contents[this.contentIndex].actions.push('+' + this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key));
                    this.setColumnHeaders(this.contents[this.contentIndex].template);
                    this.newColumnFormula(this.cell.key, false);
                }
            },
            insertIntoRight() {
                if (this.cell.key != null) {
                    for (var i = 0; i < this.contents[this.contentIndex].template.length; i++) {
                        this.contents[this.contentIndex].template[i].columns.splice(this.cell.key + 1, 0, {'component': null, 'value': null});
                    }
                    this.contents[this.contentIndex].actions.push(this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key) + '+');
                    this.setColumnHeaders(this.contents[this.contentIndex].template);
                    this.newColumnFormula(this.cell.key, true);
                }
            },
            removeColumn() {
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;

                try {
                    if (this.cell.key != null && this.contents[this.contentIndex].template[0].columns.length > 1) {
                        for (var i = 0; i < this.contents[this.contentIndex].template.length; i++) {
                            this.contents[this.contentIndex].template[i].columns.splice(this.cell.key, 1);
                        }
                        this.contents[this.contentIndex].actions.push(this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key) + '-');

                        this.setColumnHeaders(this.contents[this.contentIndex].template);

                        for (var j = 0; j < this.contents[this.contentIndex].template.length; j++) {
                            for (var k = 0; k < this.contents[this.contentIndex].template[j].columns.length; k++) {
                                if (this.contents[this.contentIndex].template[j].columns[k].component == 'FORMULA' && this.contents[this.contentIndex].template[j].columns[k].value != null) {

                                    formulas = this.parseToken(this.contents[this.contentIndex].template[j].columns[k].value.substring(1), j, k);
                                    if (formulas != null && formulas.length > 0) {
                                        formulas.slice().reverse().forEach((formula: any) => {
                                            if (formula.type == 'operand' && formula.subtype != 'text' && formula.subtype != 'number') {
                                                if (formula.value.indexOf('!') == -1) {
                                                    if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                                        keys = formula.value.split(':');

                                                        letterStart = this.getLetter(keys[0]);
                                                        letterEnd = this.getLetter(keys[1]);
                                                        startNumber = this.getNumber(keys[0]);
                                                        endNumber = this.getNumber(keys[1]);

                                                        if (letterStart == this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key) && letterEnd == this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key)) {
                                                            this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber) + ':' + (letterEnd + endNumber), '#REF!');
                                                        }

                                                        if (letterEnd >= this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key)) {
                                                            this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterEnd + endNumber), (this.getLetterByCurrentStep(letterEnd, -1) + endNumber));
                                                        }

                                                        if (letterStart > this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key)) {
                                                            this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), (this.getLetterByCurrentStep(letterStart, -1) + startNumber));
                                                        }
                                                    }

                                                    else {
                                                        letterStart = this.getLetter(formula.value);
                                                        startNumber = this.getNumber(formula.value);

                                                        if (letterStart == this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key)) {
                                                            this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), '#REF!');
                                                        }

                                                        else if (letterStart > this.getLetterByCurrentStep(String.fromCharCode(64 + 1), this.cell.key)) {
                                                            this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), (this.getLetterByCurrentStep(letterStart, -1) + startNumber));
                                                        }

                                                    }
                                                }
                                                
                                            }
                                        });
                                    }
                                }
                            }
                        }

                        this.updateOtherTemplate(this.headerCode, this.cell.key, false, null, "column");
                    }
                }

                finally {
                    endNumber = null;
                    startNumber = null;
                    letterEnd = null;
                    letterStart = null;
                    keys = null;
                    formulas = null;
                }
            },
            insertComponent(component: any) {
                if (this.cell.key != null) {
                    const rowIndex = this.getRowIndex(this.cell.key);
                    const columnIndex = this.getColumnIndex(this.cell.key);
                    this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component = component;

                    if (component == 'DATETIME') {
                        this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].value = 'CurrentDate';
                    }
                    if (component == 'NUMBER') {
                        this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].value = '0';
                    }
                    if (component == 'LONGLABEL' || component == 'LONGTEXT') {
                        this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].settings = {"colspan": 1};
                    }
                    if (component == 'VALUE' || component == 'FORMULA' || component == 'NUMBER') {
                        this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].settings = {"isPercentage": false};
                        this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].settings = {"decimalPlaces": 'auto'};
                    }

                    this.inputFocus(rowIndex, columnIndex);
                    this.onChangeCellFormulaAndHeader(rowIndex, this.columnHeaders[columnIndex].header, this.contents[this.contentIndex].template[rowIndex].columns[columnIndex]);
                }
            },
            removeCellComponent(key: any, component: any) {
                const columnIndex = this.getColumnIndex(key)
                const rowIndex = this.getRowIndex(key);
                this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component = null;
                this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].value = null;
                delete this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].settings;

                if (component == 'LONGLABEL' || component == 'LONGTEXT') {                
                    var elements = document.getElementsByClassName(key);
                    if (elements != null && elements.length > 0) {
                        var element = null as any;
                        for (var i = 0; i < elements.length; i++) {
                            elements[i]?.parentElement?.removeAttribute('colspan');

                            element = elements[i]?.parentElement?.nextElementSibling;
                            while (element) {
                                (element as HTMLElement).style.display = '';
                                element = element.nextElementSibling;
                            }
                        }
                        element = null as any;
                    }
                    elements = null as any;
                }
                this.updateHeader(columnIndex, true);
            },
            scrollScrollbar(rowIndex: any, columnIndex: any) {
                setTimeout(() => {
                    var sheetHeight = document.getElementsByClassName('p-dialog')[0].clientHeight - (document.getElementsByClassName('p-dialog-header')[0].clientHeight) - 41.33;
                    var sheetWidth = document.getElementsByClassName('p-dialog')[0].clientWidth - 64;

                    document.getElementsByClassName('p-dialog-content')[0].scrollTop = ((rowIndex) < Math.round(sheetHeight / 39.44)) ? 0 : (((rowIndex) - (Math.round((sheetHeight / 39.44)) / 2)) * 39.44) + 41.33;
                    document.getElementsByClassName('p-dialog-content')[0].scrollLeft = ((columnIndex + 2) < (Math.round(sheetWidth / 143.29))) ? 0 : (((columnIndex + 2) - ((Math.round(sheetWidth / 143.29)) / 2)) * 143.29) + 64;
                }, 0);
            },
            onFocusChange(rowIndex: any, columnIndex: any) {
                if (rowIndex != null && columnIndex != null) {
                    var inputElements = null as any;
                    var inputField = null as any;

                    try {
                        inputElements = document.getElementsByClassName(this.getHeader(rowIndex, columnIndex));
                        if (inputElements != null) {
                            inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                            if (this.contents[this.contentIndex].template[rowIndex] != null && this.contents[this.contentIndex].template[rowIndex].columns[columnIndex] != null) {
                                if (['TEXT', 'LONGTEXT'].includes(this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component)) {
                                    inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                                }

                                else if (['FORMULA'].includes(this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component)) {
                                    if (this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].actualValue != null && isNaN(this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].actualValue)) {
                                        inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                                    }
                                }

                                else if (['VALUE'].includes(this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component)) {
                                    inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                                }

                                inputField?.focus();
                                inputField?.setSelectionRange(inputField.value.length, inputField.value.length);
                            }
                        }
                    }

                    finally {
                        inputField = null;
                        inputElements = null;
                    }
                }
            },
            async navigateCellComponent(key: any) {
                if (this.formulaDialog.visible || this.valueDialog.visible) {
                    this.contentIndex = 1;
                    this.navigateCell = true;
                    var sheetIndex = -1;
                    var targetRowIndex = -1;
                    var targetColIndex = -1;
                    var keys = null;
                    var code = null as any;

                    if (this.formulaDialog.visible) {
                        if (this.formulaDialog.formula.indexOf('!') != -1) {
                            keys = this.formulaDialog.formula.split('!');
                            code = (this.formulaDialog.formula.match(/([A-Za-z0-9_]+)!/g))![0].replace('!', '');

                            targetRowIndex = this.getRowIndex(keys[1]);
                            targetColIndex = this.getColumnIndex(keys[1]);

                            sheetIndex = this.sheets.findIndex(x => x.code == code && x.template != null);
                        }
                    }

                    else if (this.valueDialog.visible) {
                        if (this.valueDialog.value.indexOf('!') != -1) {
                            keys = this.valueDialog.value.split('!');
                            code = (this.valueDialog.value.match(/([A-Za-z0-9_]+)!/g))![0].replace('!', '');

                            targetRowIndex = this.getRowIndex(keys[1]);
                            targetColIndex = this.getColumnIndex(keys[1]);

                            sheetIndex = this.rpkSheets.findIndex(x => x.code == code);
                            this.isRpkSheet = true;
                        }
                    }

                    if (sheetIndex != -1 && targetRowIndex != -1 && targetColIndex != -1) {
                        this.noNavigateSheet = false;
                        this.navigateValue = this.formulaDialog.visible ? this.sheets[sheetIndex] : this.rpkSheets[sheetIndex];
                        await this.onNavigateChange(this.formulaDialog.visible ? this.formulaDialog.rowIndex : this.valueDialog.rowIndex, this.formulaDialog.visible ? this.formulaDialog.columnIndex : this.valueDialog.columnIndex);

                        this.scrollScrollbar(targetRowIndex, targetColIndex);

                        // setTimeout(() => {
                            this.onFocusChange(targetRowIndex, targetColIndex);
                        // }, 0);
                    }

                    else {
                        this.noNavigateSheet = true;
                        this.contentIndex = 0;
                    }
                    code = null as any;
                    keys = null as any;
                }

                else {
                    this.contentIndex = 0;
                    if (this.navigateValue != null) {
                        if (!this.isRpkSheet) {
                            //this.contents[this.contentIndex].template[this.navigateRowIndex].columns[this.navigateColumnIndex].value = '=' + this.navigateValue['code'] + '!' + key;
                            this.openFormulaDialog(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex, true);
                            if (this.formulaDialog.formula == null) {
                                this.formulaDialog.formula = "";
                            }
                            this.appendFormula(key);
                        }

                        else {
                            this.openValueDialog(this.valueDialog.rowIndex, this.valueDialog.columnIndex, true);
                            this.valueDialog.value = '=' + this.navigateValue['code'] + '!' + key;    
                            this.isRpkSheet = false;
                        }
                        
                    }

                    this.calculateTableWidthHeight();

                    this.contents.splice(1, 1);

                    document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
                }
            },
            onNavigateBack() {
                this.contentIndex = 0;

                this.calculateTableWidthHeight();

                this.contents.splice(1, 1);

                if (this.navigateCell) {
                    this.navigateCell = false;
                }

                // Reached by F9 from the grid: put the cursor back on the cell that was followed
                // rather than opening a dialog the user never asked for.
                if (this.shortcutNavigate) {
                    this.shortcutNavigate = false;
                    this.isRpkSheet = false;
                    this.isNavigate = false;
                    this.tempFormula = null;
                    this.tempValue = null;
                    document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
                    this.onFocusChange(this.shortcutOrigin.rowIndex, this.shortcutOrigin.columnIndex);
                    return;
                }

                if (!this.isRpkSheet) {
                    this.openFormulaDialog(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex, true);
                }

                else {
                    this.openValueDialog(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex, true);
                    this.isRpkSheet = false;
                }

                document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
            },
            async onNavigateChange(rowIndex: any, columnIndex: any) {
                this.navigateRowIndex = rowIndex;
                this.navigateColumnIndex = columnIndex;

                let r0 = this.valueDialog.visible 
                    ? templateApi.templateViewBySheet(
                        this.valueDialog.selectedNavigate != null ? this.valueDialog.selectedNavigate.identifier : this.navigateValue?.['identifier'], 
                        {templateId: this.template.identifier, sheetId: this.template.sheet.identifier, version: this.template.version}
                    ) 
                    : null;

                if (this.formulaDialog.visible) {
                    if (this.formulaDialog.selectedNavigate != null) {
                        this.navigateValue = this.formulaDialog.selectedNavigate;
                    }

                    this.hideDialog();

                    if (this.navigateValue != null && !this.navigateValue['isError']) {
                        this.contents.push(this.navigateValue['template']['content']);
                        this.contentIndex = 1;
                        this.calculateTableWidthHeight();
                        document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
                    }
                }

                else if (this.valueDialog.visible) {
                    try {
                        const response = await r0;
                        
                        if (this.valueDialog.selectedNavigate != null) {
                            this.valueDialog.selectedNavigate['template'] = {};
                            this.valueDialog.selectedNavigate['template']['identifier'] = response?.data.template.identifier;
                            this.valueDialog.selectedNavigate['template']['content'] = response?.data.template.content;
                            this.navigateValue = this.valueDialog.selectedNavigate;
                        }

                        else if (this.navigateValue != null) {
                            this.navigateValue['template'] = {};
                            this.navigateValue['template']['identifier'] = response?.data.template.identifier;
                            this.navigateValue['template']['content'] = response?.data.template.content;
                        }

                        this.hideDialog();

                        if (this.navigateValue != null && !this.navigateValue['isError']) {
                            this.isRpkSheet = true;
                            this.contents.push(this.navigateValue['template']['content']);
                            this.contentIndex = 1;
                            this.calculateTableWidthHeight();
                            document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
                        }
                    } 
                    
                    catch (error) {
                        if (this.valueDialog.selectedNavigate != null) {
                            this.valueDialog.selectedNavigate.isError = true;
                        }
                    }
                }
            },
            save() {
                this.$emit('save', this.contents[0]);
            },
            update() {
                // this.$emit('update', this.contents[0], null);
                // var navigateIds = JSON.parse(JSON.stringify(this.navigateIds));
                // navigateIds.forEach((navigateId: any, index: any) => {
                //     this.$emit('update', this.sheets[navigateId].template.content, this.sheets[navigateId]);
                //     this.navigateIds.splice(index, 1);
                // });
                // navigateIds = null as any;

                this.$emit('update', this.contents[0], this.affectedSheetContents, null);
                this.affectedSheetContents = [];
            },
            preview() {
                //
            },
            cancel() {
                this.formulaHeader = "-";
                this.cellTitleHeader = "-";
                this.isShowFormulaHeader = false;
                this.affectedSheetContents = [];
                this.$emit('cancel');
            },
            openFormulaDialog(rowIndex: any, columnIndex: any, isNavigate: any) {
                this.formulaDialog.rowIndex = rowIndex;
                this.formulaDialog.columnIndex = columnIndex;

                this.formulaDialog.header = this.contents[this.contentIndex].template[this.formulaDialog.rowIndex].columns[this.formulaDialog.columnIndex].header;
                if (isNavigate) {
                    this.formulaDialog.formula = this.tempFormula;
                }

                else {
                    this.formulaDialog.selectedNavigate = null;
                    this.formulaDialog.formula = this.contents[this.contentIndex].template[this.formulaDialog.rowIndex].columns[this.formulaDialog.columnIndex].value;
                }

                this.formulaDialog.visible = true;
            },
            newRowFormula(key: any, isBelow: any) {
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;

                for (var j = 0; j < this.contents[this.contentIndex].template.length; j++) {
                    for (var k = 0; k < this.contents[this.contentIndex].template[j].columns.length; k++) {
                        if (this.contents[this.contentIndex].template[j].columns[k].component == 'FORMULA' && this.contents[this.contentIndex].template[j].columns[k].value != null) {
                            formulas = this.parseToken(this.contents[this.contentIndex].template[j].columns[k].value.substring(1), j, k);
                            if (formulas != null && formulas.length > 0) {
                                formulas.slice().reverse().forEach((formula: any) => {
                                    if (formula.type == 'operand' && formula.subtype != 'text' && formula.subtype != 'number') {
                                        if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                            keys = formula.value.split(':');

                                            letterStart = this.getLetter(keys[0]);
                                            letterEnd = this.getLetter(keys[1]);
                                            startNumber = this.getNumber(keys[0]);
                                            endNumber = this.getNumber(keys[1]);

                                            if ((isBelow && endNumber > (key + 1)) || (!isBelow && endNumber >= (key + 1))) {
                                                this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterEnd + endNumber), letterEnd + (endNumber + 1));
                                            }

                                            if ((isBelow && startNumber > (key + 1)) || (!isBelow && startNumber >= (key + 1))) {
                                                this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber + 1));
                                            }
                                        }

                                        else {
                                            letterStart = this.getLetter(formula.value);
                                            startNumber = this.getNumber(formula.value);

                                            if ((isBelow && startNumber > (key + 1)) || (!isBelow && startNumber >= (key + 1))) {
                                                this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber + 1));
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
                this.updateOtherTemplate(this.headerCode, key, true, isBelow == true ? "below" : "above", null);
                endNumber = null;
                startNumber = null;
                letterEnd = null;
                letterStart = null;
                keys = null;
                formulas = null;
            },
            newColumnFormula(key: any, isRight: any) {
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;
                for (var j = 0; j < this.contents[this.contentIndex].template.length; j++) {
                    for (var k = 0; k < this.contents[this.contentIndex].template[j].columns.length; k++) {
                        if (this.contents[this.contentIndex].template[j].columns[k].component == 'FORMULA' && this.contents[this.contentIndex].template[j].columns[k].value != null) {
                            formulas = this.parseToken(this.contents[this.contentIndex].template[j].columns[k].value.substring(1), j, k);
                            if (formulas != null && formulas.length > 0) {
                                formulas.slice().reverse().forEach((formula: any) => {
                                    if (formula.type == 'operand' && formula.subtype != 'text' && formula.subtype != 'number') {
                                        if (formula.value.indexOf('!') == -1) {
                                            if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                                keys = formula.value.split(':');

                                                letterStart = this.getLetter(keys[0]);
                                                letterEnd = this.getLetter(keys[1]);
                                                startNumber = this.getNumber(keys[0]);
                                                endNumber = this.getNumber(keys[1]);

                                                if ((isRight && letterEnd > this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key)) || (!isRight && letterEnd >= this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key))) {
                                                    this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterEnd + endNumber), (this.getLetterByCurrentStep(letterEnd, 1) + endNumber));
                                                }

                                                if ((isRight && letterStart > this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key)) || (!isRight && letterStart >= this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key))) {
                                                    this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), (this.getLetterByCurrentStep(letterStart, 1) + startNumber));
                                                }
                                            }

                                            else {
                                                letterStart = this.getLetter(formula.value);
                                                startNumber = this.getNumber(formula.value);

                                                if ((isRight && letterStart > this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key)) || (!isRight && letterStart >= this.getLetterByCurrentStep(String.fromCharCode(64 + 1), key))) {
                                                    this.contents[this.contentIndex].template[j].columns[k].value = this.contents[this.contentIndex].template[j].columns[k].value.replace((letterStart + startNumber), (this.getLetterByCurrentStep(letterStart, 1) + startNumber));
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
                this.updateOtherTemplate(this.headerCode, key, true, isRight == true ? "right" : "left", null);
                endNumber = null;
                startNumber = null;
                letterEnd = null;
                letterStart = null;
                keys = null;
                formulas = null;
            },
            findAffectedTemplate(sheetIndex: any) {                
                var foundTemplate = null as any;
                foundTemplate = {content: this.sheets[sheetIndex].template.content, identifier: this.sheets[sheetIndex].template.identifier, sheet: {identifier: this.sheets[sheetIndex].identifier}}
                if (!this.affectedSheetContents.some(item => item.identifier == foundTemplate.identifier)) {
                    this.affectedSheetContents.push(foundTemplate)
                }
            },
            updateOtherTemplate(code: any, key: any, isInsert: any, insertFrom: any, removeFrom: any) {
                var template = null as any;
                var templateChecking = null as any;
                var formula = null as any;
                var cell = null as any;
                var letter = null as any;
                var number = null as any;
                var formulas = null as any;
                var templateCode = null as any;
                var keys = null as any;
                var isNoRef = false;
                // code = '=' + code;
                this.sheets.forEach((sheet: any, index: any) => {
                    template = sheet.template;
                    templateChecking = JSON.stringify(template);
                    if (template != null && templateChecking.indexOf(code + '!') != -1) {
                        template.content.template.forEach((row: any, rowIndex: any) => {
                            row.columns.forEach((item: any, columnIndex: any) => {
                                if (item.component != null && (item.component == 'NAVIGATE' || item.component == 'FORMULA') && this.sheets[index].template.content.template[rowIndex].columns[columnIndex].value != null) {
                                    formulas = this.parseToken(this.sheets[index].template.content.template[rowIndex].columns[columnIndex].value.substring(1), rowIndex, columnIndex);
                                    if (isInsert) {
                                        if (formulas != null && formulas.length > 0) {
                                            let newConstructedFormula = "";

                                            formulas.forEach((formula: any, formulaIndex: any) => {
                                                if (formula.type == "operand" && formula.subtype == "range") {
                                                    if (formula.value.indexOf('!') != -1) {
                                                        keys = formula.value.split('!');
                                                        if (keys[0] == code) {
                                                            if (keys[1].indexOf(':') != -1) {
                                                                templateCode = keys[0];
                                                                keys = keys[1].split(':');
                                                                let newKeys = keys.map((newKey: any) => {
                                                                    letter = this.getLetter(newKey);
                                                                    number = this.getNumber(newKey);
                                                                    if (insertFrom == "right" && this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), insertFrom) || (insertFrom == "left" && this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), insertFrom))) {
                                                                        if (!this.navigateIds.includes(index)) {
                                                                            this.navigateIds.push(index);
                                                                        }
                                                                        
                                                                        return newKey = this.getLetterByCurrentStep(letter, 1) + number;
                                                                    }
                                                                    if ((insertFrom == "above" && number >= (key + 1)) || (insertFrom == "below" && number > (key + 1))) {
                                                                        if (!this.navigateIds.includes(index)) {
                                                                            this.navigateIds.push(index);
                                                                        }
                                                                        return newKey = this.getLetterByCurrentStep(letter, 0) + (number + 1)
                                                                    }
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    return newKey = this.getLetterByCurrentStep(letter, 0) + number;
                                                                });
                                                                formula.value = templateCode + '!' + formula.value.replace(formula.value, newKeys.join(':'));
                                                                this.findAffectedTemplate(index);
                                                            }
                                                            else {
                                                                letter = this.getLetter(keys[1]);
                                                                number = this.getNumber(keys[1]);
                                                                if (insertFrom == "right" && this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), false) || (insertFrom == "left" && this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), true))) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = formula.value.replace(formula.value, (keys[0] + '!' + this.getLetterByCurrentStep(letter,1) + number));
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                                if ((insertFrom == "above" && number >= (key + 1)) || (insertFrom == "below" && number > (key + 1))) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = formula.value.replace(formula.value, (keys[0] + '!' + this.getLetterByCurrentStep(letter,0) + (number + 1)));
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            });

                                            formulas.forEach((formula:any) => {
                                                if(newConstructedFormula == "") {
                                                    newConstructedFormula += "="
                                                }


                                                if(formula.type == 'function' && formula.subtype == 'start'){
                                                    newConstructedFormula += formula.value + "(";
                                                }
                                                else if(formula.type == 'function' && formula.subtype == 'stop') {
                                                    newConstructedFormula += formula.value + ")";
                                                }
                                                else if(formula.type == 'operand' && formula.subtype == 'text') {
                                                    newConstructedFormula += '"' + formula.value + '"';
                                                }
                                                else if(formula.type == 'argument'){
                                                    newConstructedFormula += formula.value + " ";
                                                }
                                                else {
                                                    newConstructedFormula += formula.value;
                                                }
                                            })

                                            this.sheets[index].template.content.template[rowIndex].columns[columnIndex].value = newConstructedFormula
                                        }
                                    }

                                    else {
                                        if (formulas != null && formulas.length > 0) {
                                        let newConstructedFormula = "";

                                        formulas.forEach((formula: any, formulaIndex: any) => {
                                            if (formula.type == "operand" && formula.subtype == 'range') {
                                                if (formula.value.indexOf('!') != -1) {
                                                    keys = formula.value.split('!');
                                                    if (keys[0] == code) {
                                                        if (keys[1].indexOf(':') != -1) {
                                                            templateCode = keys[0]
                                                            keys = keys[1].split(':');
                                                            let newKeys = keys.map((newKey: any, keyIndex:any) => {
                                                                if (removeFrom == "column") {
                                                                    if (this.getLetter(keys[0]) == this.getLetterByCurrentStep(String.fromCharCode(65), key) && this.getLetter(keys[1]) == this.getLetterByCurrentStep(String.fromCharCode(65), key)) {
                                                                        isNoRef = true;
                                                                    }
                                                                    else {
                                                                        letter = this.getLetter(newKey);
                                                                        number = this.getNumber(newKey);
                                                                        if (this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), true)) {
                                                                            if (letter == this.getLetterByCurrentStep(String.fromCharCode(65), key) && keyIndex == 0) {
                                                                                return newKey = this.getLetterByCurrentStep(letter, 0) + number;
                                                                            }
                                                                            if (!this.navigateIds.includes(index)) {
                                                                                this.navigateIds.push(index);
                                                                            }
                                                                            return newKey = this.getLetterByCurrentStep(letter, -1) + number;
                                                                        }
                                                                        return newKey = this.getLetterByCurrentStep(letter, 0) + number;
                                                                    }
                                                                }
                                                                else if (removeFrom == "row") {
                                                                    if ((this.getNumber(keys[0]) == (key + 1)) && (this.getNumber(keys[1]) == (key + 1))) {
                                                                        isNoRef = true
                                                                    }
                                                                    else {
                                                                        letter = this.getLetter(newKey);
                                                                        number = this.getNumber(newKey);
                                                                        if (number >= key + 1) {
                                                                            if (number == key + 1 && keyIndex == 0) {
                                                                                return newKey = this.getLetterByCurrentStep(letter, 0) + number
                                                                            }
                                                                            if (!this.navigateIds.includes(index)) {
                                                                                this.navigateIds.push(index);
                                                                            }
                                                                            return newKey = this.getLetterByCurrentStep(letter, 0) + (number - 1);
                                                                        }
                                                                        return newKey = this.getLetterByCurrentStep(letter, 0) + number
                                                                    }
                                                                }
                                                            });
                                                            if (isNoRef == true) {
                                                                formula.value = '#REF!';
                                                                this.findAffectedTemplate(index);
                                                                if (!this.navigateIds.includes(index)) {
                                                                    this.navigateIds.push(index);
                                                                }
                                                            }
                                                            else {
                                                                formula.value = templateCode + '!' + formula.value.replace(formula.value, newKeys.join(':'));
                                                                this.findAffectedTemplate(index);
                                                                if (!this.navigateIds.includes(index)) {
                                                                    this.navigateIds.push(index);
                                                                }
                                                            }
                                                            isNoRef = false
                                                        }
                                                        else {
                                                            letter = this.getLetter(keys[1]);
                                                            number = this.getNumber(keys[1]);
                                                            if (removeFrom == "column") {
                                                                if (this.compareByColumn(letter, this.getLetterByCurrentStep(String.fromCharCode(65), key), false)) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = formula.value.replace(formula.value, (keys[0] + '!' + this.getLetterByCurrentStep(letter, -1) + number));
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                                else if (letter == this.getLetterByCurrentStep(String.fromCharCode(65), key)) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = '#REF!';
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                            }
                                                            else if (removeFrom == "row") {
                                                                if (number > (key + 1)) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = formula.value.replace(formula.value, (keys[0] + '!' + this.getLetterByCurrentStep(letter, 0) + (number -1)))
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                                else if (number == (key + 1)) {
                                                                    if (!this.navigateIds.includes(index)) {
                                                                        this.navigateIds.push(index);
                                                                    }
                                                                    formula.value = '#REF!';
                                                                    this.findAffectedTemplate(index);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        })

                                        formulas.forEach((formula:any) => {
                                            if(newConstructedFormula == "") {
                                                newConstructedFormula += "="
                                            }


                                            if(formula.type == 'function' && formula.subtype == 'start'){
                                                newConstructedFormula += formula.value + "(";
                                            }
                                            else if(formula.type == 'function' && formula.subtype == 'stop') {
                                                newConstructedFormula += formula.value + ")";
                                            }
                                            else if(formula.type == 'operand' && formula.subtype == 'text') {
                                                newConstructedFormula += '"' + formula.value + '"';
                                            }
                                            else if(formula.type == 'argument'){
                                                newConstructedFormula += formula.value + " ";
                                            }
                                            else {
                                                newConstructedFormula += formula.value;
                                            }
                                        })

                                        this.sheets[index].template.content.template[rowIndex].columns[columnIndex].value = newConstructedFormula
                                        }
                                    }
                                }
                            });
                        });
                    }
                });
                number = null;
                letter = null;
                cell = null;
                formula = null;
                templateChecking = null;
                template = null;
            },
            clearFormula() {
                this.contents[this.contentIndex].template[this.formulaDialog.rowIndex].columns[this.formulaDialog.columnIndex].value = null;
                this.formulaDialog.visible = false;
            },
            appendFormula(key: any) {
                let head = "";
                let tail = "";
                
                if (this.formulaDialog.formula == null){
                    this.formulaDialog.formula = ""
                }

                if (this.formulaDialog.formulaInput.startIndex != null && this.formulaDialog.formulaInput.endIndex != null) {
                    head = this.formulaDialog.formula.substring(0, this.formulaDialog.formulaInput.startIndex);
                    tail = this.formulaDialog.formula.substring(this.formulaDialog.formulaInput.endIndex, this.formulaDialog.formula.length);
                }

                else {
                    head = this.formulaDialog.formula;
                }

                if (this.navigateValue != null && key != null) {
                    this.formulaDialog.formula = head + this.navigateValue['code'] + '!' + key + tail;
                }

                else {
                    this.formulaDialog.formula = head + this.formulaDialog.selectedFormula + "()" + tail;
                }
            },
            saveFormula() {
                this.contents[this.contentIndex].template[this.formulaDialog.rowIndex].columns[this.formulaDialog.columnIndex].value = this.formulaDialog.formula;
                this.formulaDialog.visible = false;
                this.formulaDialog.formulaInput.startIndex = null;
                this.formulaDialog.formulaInput.endIndex = null;
                this.formulaDialog.selectedFormula = null;
                this.formulaDialog.selectedNavigate = null;
                this.formulaDialog.formula = null;
            },
            closeFormula() {
                if (!this.isNavigate) {
                    this.formulaDialog.visible = false;
                    this.formulaDialog.formulaInput.startIndex = null;
                    this.formulaDialog.formulaInput.endIndex = null;
                    this.formulaDialog.formula = null;
                    this.formulaDialog.selectedFormula = null;
                    this.formulaDialog.selectedNavigate = null;
                    this.onFocusChange(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex)
                }

                else {
                    this.isNavigate = false;
                }
            },
            hideDialog() {
                this.isNavigate = true;
                if (this.formulaDialog.visible) {
                    this.formulaDialog.visible = false;
                    this.tempFormula = this.formulaDialog.formula;
                }

                else if (this.valueDialog.visible) {
                    this.valueDialog.visible = false;
                    this.tempValue = this.valueDialog.value;
                }
            },
            openValueDialog(rowIndex: any, columnIndex: any, isNavigate: any) {
                this.valueDialog.rowIndex = rowIndex;
                this.valueDialog.columnIndex = columnIndex;

                this.valueDialog.visible = true;

                if (isNavigate) {
                    this.valueDialog.value = this.tempValue;
                }

                else {
                    this.valueDialog.selectedNavigate = null;
                    this.valueDialog.value = this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].value;
                }

            },
            clearValue() {
                this.contents[this.contentIndex].template[this.valueDialog.rowIndex].columns[this.valueDialog.columnIndex].value = null;
                this.valueDialog.visible = false;
            },
            saveValue() {                
                this.contents[this.contentIndex].template[this.valueDialog.rowIndex].columns[this.valueDialog.columnIndex].value = this.valueDialog.value;
                this.valueDialog.visible = false;
                this.valueDialog.selectedNavigate = null;
            },
            closeValue() {
                if (!this.isNavigate) {
                    this.valueDialog.visible = false;
                    this.valueDialog.selectedNavigate = null;
                    this.onFocusChange(this.valueDialog.rowIndex, this.valueDialog.columnIndex)
                }

                else {
                    this.isNavigate = false;
                }
            },
            showStyle(rowIndex: any, columnIndex: any, force: any) {
                const component = this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].component;
                if (force || rowIndex != this.styleComponent.rowIndex || columnIndex != this.styleComponent.columnIndex) {
                    this.styleComponent.visible = true;
                }

                else {
                    this.styleComponent.visible = !this.styleComponent.visible;
                }
                this.styleComponent.rowIndex = rowIndex;
                this.styleComponent.columnIndex = columnIndex;
                this.styleComponent.component = component;
                this.styleComponent.style = this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].style;
                this.styleComponent.settings = this.contents[this.contentIndex].template[rowIndex].columns[columnIndex].settings;
                this.styleComponent.sheetInfo = {
                    template: this.contents[this.contentIndex].template,
                    numCols: this.columnHeaders.length,
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                };
            },
            updateStyle(style: any) {
                this.contents[this.contentIndex].template[this.styleComponent.rowIndex].columns[this.styleComponent.columnIndex].style = style;
            },
            updateSettings(settings: any){
                const cell = this.contents?.[this.contentIndex]?.template?.[this.styleComponent.rowIndex]?.columns?.[this.styleComponent.columnIndex];
                cell.settings = { ...cell.settings, ...settings };

                // if (cell.component == 'NUMBER' && settings.decimalPlaces != null) {
                //     cell.value = settings.decimalPlaces;
                // }
            },
            inputFocus(rowIndex: any, columnIndex: any) {
                this.focusCell.rowIndex = rowIndex;
                this.focusCell.columnIndex = columnIndex;
                this.showStyle(rowIndex, columnIndex, true);
            },
            // Bound when the dialog shows and dropped when it hides, the way TheSheetsDialog binds
            // its own F1-F10 keys: mounted() is too early here, since this component stays mounted
            // behind the Template tab for the whole page.
            setKeyPressDetection() {
                window.addEventListener('keydown', this.detectKeyPress);
            },
            removeKeyPressDetection() {
                window.removeEventListener('keydown', this.detectKeyPress);
            },
            detectKeyPress(event: any) {
                if (this.isPageLoading) {
                    return;
                }

                switch (event.key) {
                    // Go to link cell: follow the first sheet reference in the focused cell.
                    case 'F9': {
                        event.preventDefault();
                        this.blurFocusCell();
                        setTimeout(() => {
                            this.goToLinkCell();
                        }, 0);
                        break;
                    }
                    // Go back to the last sheet.
                    case 'F10': {
                        event.preventDefault();
                        this.blurFocusCell();
                        setTimeout(() => {
                            this.goBackScreen();
                        }, 0);
                        break;
                    }
                }
            },
            // The cell input keeps the caret and swallows what follows; TheSheetsDialog blurs it
            // before acting on F7/F8/F10 for the same reason.
            blurFocusCell() {
                if (this.focusCell.rowIndex == null || this.focusCell.columnIndex == null) {
                    return;
                }

                var inputElements = null as any;
                var inputField = null as any;

                try {
                    inputElements = document.getElementsByClassName(this.getHeader(this.focusCell.rowIndex, this.focusCell.columnIndex));
                    if (inputElements != null) {
                        inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                        inputField?.blur();
                    }
                }

                finally {
                    inputField = null;
                    inputElements = null;
                }
            },
            async goToLinkCell() {
                // Inside the formula/value dialog F9 is the navigate arrow, so a reference being
                // typed can be followed without reaching for the mouse.
                if (this.formulaDialog.visible || this.valueDialog.visible) {
                    const typed = this.formulaDialog.visible ? this.formulaDialog.formula : this.valueDialog.value;
                    if (typed == null || typed.indexOf('!') == -1) {
                        this.$toast.add({severity: "warn", summary: "No link", detail: "This formula has no sheet reference to go to.", life: 3000});
                        return;
                    }
                    await this.navigateCellComponent(null);
                    return;
                }

                if (this.contentIndex != 0) {
                    this.$toast.add({severity: "warn", summary: "No link", detail: "Press F10 to go back before following another link.", life: 3000});
                    return;
                }

                const rowIndex = this.focusCell.rowIndex;
                const columnIndex = this.focusCell.columnIndex;
                const cell = (rowIndex == null || columnIndex == null)
                    ? null
                    : this.contents[this.contentIndex].template[rowIndex]?.columns[columnIndex];
                if (cell == null || !(cell.component == 'NAVIGATE' || cell.component == 'VALUE' || cell.component == 'FORMULA') || cell.value == null || String(cell.value).indexOf('!') == -1) {
                    this.$toast.add({severity: "warn", summary: "No link", detail: "Select a cell whose formula points at another sheet, then press F9.", life: 3000});
                    return;
                }

                this.shortcutNavigate = true;
                this.shortcutOrigin.rowIndex = rowIndex;
                this.shortcutOrigin.columnIndex = columnIndex;

                // Same pair the cell's own navigate button runs: open the matching dialog so
                // navigateCellComponent reads the reference from it, then follow it.
                if (cell.component == 'FORMULA') {
                    this.openFormulaDialog(rowIndex, columnIndex, false);
                }

                else {
                    this.openValueDialog(rowIndex, columnIndex, false);
                }

                await this.navigateCellComponent(null);

                // navigateCellComponent leaves the dialog open on a miss; nothing asked for it to
                // be open, so close it and say why instead.
                if (this.contentIndex == 0) {
                    this.shortcutNavigate = false;
                    this.noNavigateSheet = false;
                    this.formulaDialog.visible = false;
                    this.valueDialog.visible = false;
                    this.$toast.add({severity: "error", summary: "Link not found", detail: "The sheet this cell points at is not available.", life: 6000});
                }
            },
            goBackScreen() {
                // One step at a time, outwards: formula dialog, linked sheet, then the template.
                if (this.formulaDialog.visible) {
                    this.formulaDialog.visible = false;
                }

                else if (this.valueDialog.visible) {
                    this.valueDialog.visible = false;
                }

                else if (this.contentIndex != 0) {
                    this.onNavigateBack();
                }

                else {
                    this.cancel();
                }
            },
            onFormulaMouseMove() {
                const input = document.getElementById('formula-input-text') as HTMLInputElement;
                this.formulaDialog.formulaInput.startIndex = input.selectionStart;
                this.formulaDialog.formulaInput.endIndex = input.selectionEnd;
            },
            updateHeader(colIndex: any, isClearTimeout: any) {
                if (isClearTimeout) {
                    clearTimeout(this.valueTimeout);
                }
                this.valueTimeout = setTimeout(() => {
                    let colHeader = "";
                    for (let i = 0; i < this.contents[this.contentIndex].template.length; i++) {
                        let rowHeader = this.contents[this.contentIndex].template[i].columns[0].value;
                        if (this.contents[this.contentIndex].template[i].columns[colIndex].component == "HEADER" || this.contents[this.contentIndex].template[i].columns[colIndex].component == "HEADERTEXT") {
                            if (i > 0) {
                                if (this.contents[this.contentIndex].template[i - 1].columns[colIndex].component != "HEADER" && this.contents[this.contentIndex].template[i - 1].columns[colIndex].component != "HEADERTEXT") {
                                    colHeader = "";
                                }
                            }
                            colHeader += " " + this.contents[this.contentIndex].template[i].columns[colIndex].value;
                            continue;
                        }

                        this.contents[this.contentIndex].template[i].columns[colIndex].header = "[" + this.getHeaderLetter(colIndex) + (i + 1) + "]" + " = " + rowHeader + " | " + colHeader;
                    }
                }, 0);

            },
            onChangeCellFormulaAndHeader(rowIndex: any, columnHeader: any, cellData: any) {
                rowIndex++;

                this.isShowFormulaHeader = true;
                this.cellTitleHeader = cellData.header;

                if (cellData.component == 'NUMBER') {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + cellData.value + " Decimal Place";
                }
                else if (cellData.component == 'COMPANY') {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + "Company";
                }
                else if (cellData.component == 'COMPANYDROPDOWN') {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + "Company Dropdown";
                }
                else if (cellData.component == 'CURRENCY') {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + "Currency";
                }
                else if (cellData.component == 'COUNTRY') {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + "Country";
                }
                else {
                    this.formulaHeader = "[" + columnHeader + rowIndex + "] " + cellData.value;
                }
            }
        },
        setup() {
            var cell = null as any;
            cell = {key: null as any};

            const rowMenu = ref();
            const toggleRowMenu = (event: any, key: any) => {
                cell.key = key;
                rowMenu.value.toggle(event);
            };

            const columnMenu = ref();
            const toggleColumnMenu = (event: any, key: any) => {
                cell.key = key;
                columnMenu.value.toggle(event);
            };

            const cellMenu = ref();
            const toggleCellMenu = (event: any, key: any) => {
                cell.key = key;
                cellMenu.value.toggle(event);
            };

            return {rowMenu, toggleRowMenu, columnMenu, toggleColumnMenu, cell, cellMenu, toggleCellMenu, v$: useVuelidate()};
        },
        validations() {
            return {
                valueDialog: {
                    value: {
                        required
                    },
                },
            };
        },
    });
</script>